import React from 'react'
import { useTranslation } from 'react-i18next'
import './style.css'

const TravelTipsPage = () => {
  const { t } = useTranslation()
  return (
    <div className="travel-tips optimize-visibility">
      <div className="container">
        <div className="section-title">
          <h2>{t('promo.travel_tips_title')}</h2>
        </div>
        <p>{t('promo.travel_tips_intro')}</p>
        <h3>{t('promo.travel_tips_subtitle')}</h3>
        <p>{t('promo.travel_tips_content')}</p>
        <h4>{t('promo.travel_tips_steps_title')}</h4>
        <ol>
          <li>{t('promo.travel_tips_step1')}</li>
          <li>{t('promo.travel_tips_step2')}</li>
          <li>{t('promo.travel_tips_step3')}</li>
          <li>{t('promo.travel_tips_step4')}</li>
        </ol>
        <p>{t('promo.travel_tips_conclusion')}</p>
        <h4>{t('promo.travel_tips_reasons_title')}</h4>
        <ul>
          <li>{t('promo.travel_tips_reason1')}</li>
          <li>{t('promo.travel_tips_reason2')}</li>
          <li>{t('promo.travel_tips_reason3')}</li>
          <li>{t('promo.travel_tips_reason4')}</li>
          <li>{t('promo.travel_tips_reason5')}</li>
        </ul>
        <p>{t('promo.travel_tips_final_note')}</p>
      </div>
    </div>
  )
}
export default TravelTipsPage
